export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Iniciar sesión",
    "login.form.hint.user": "Inicio de sesión",
    "login.form.hint.password": "Contraseña",
    "login.form.checkbox.remember-me": "Recordarme",
    "login.form.button.sign-in": "Iniciar sesión",
    "login.form.message.invalid-user-credentials": "El usuario o la contraseña son incorrectos",
    "login.form.message.account-temporarily-locked": "Se ha bloqueado su cuenta temporalmente. Vuelva en 5 minutos",
    "login.form.message.user-required": "Introduzca el usuario",
    "login.form.message.password-required": "Introduzca la contraseña",
    "login.form.button.forgot-password": "¿Olvidó su contraseña?",
    "error.mfa-required.title": "Configurar 2FA",
    "error.mfa-required.message1": "Se requiere autenticación de doble factor (2FA) para proteger su cuenta.",
    "error.mfa-required.message2": "Se le redirigirá a la configuración de su cuenta en el panel online. Active la autenticación de doble factor (2FA), siga las instrucciones de configuración y después vuelva aquí.",
    "error.mfa-required.learnMore": "Más información sobre 2FA",
    "error.mfa-required.continue": "Continuar",
    "error.root-admin-login.title": "Error 403 - prohibido",
    "error.root-admin-login.message": "Ha iniciado sesión como administrador de solo lectura. Para acceder a la consola de Web Recovery, inicie sesión en su lugar como inquilino de cliente o administrador.",
    "error.server-busy.message": "El servidor está ocupado. Inténtelo de nuevo más tarde.",
    "error.network-connection.title": "Error en la conexión de red",
    "error.network-connection.message": "Compruebe la conexión a Internet e inténtelo nuevamente.",
    "error.internal-server-error.title": "Error interno del servidor",
    "error.internal-server-error.message": "Para resolver el error, contacte a soporte técnico con los detalles del error:",
    "error.internal-server-error.copy.button": "Copiar"
};
